











































































































































































































import { Vue, Component, Emit } from "vue-property-decorator";
import { IdCardPaymentRequest } from '@fgl/funfangle-sdk/dist/rest/bank/payment/IdCardPaymentRequest';
import { User } from "@fgl/funfangle-sdk/dist/rest/profile";
import { ApiEndpoints } from "@/constants";
import { ApiService } from "@/shared/auth/auth-cognito";
import PaymentMethodSquare from '@/views/account/paymentmethods/square/SquarePayment.vue';
import { getModule } from "vuex-module-decorators";
import { MediaQuery as MQ } from '@/MediaQuery';
import { BankModule, NavModule, ProfileModule } from "@/store";
import ProfilePhoto from "@/components/profiles/ProfilePhotoComponent.vue";
import {
  mdbAlert,
  // mdbBtn,
  // mdbInput,
  mdbCol,
  mdbContainer,
  mdbRow,
  mdbSelect
} from "mdbvue";
import { v1 as uuidv1 } from 'uuid';
import { SquareUtils } from "../paymentmethods/square/SquareUtils";

const apiSvc = new ApiService();

// Define the props by using Vue's canonical way.
const InvoiceProps = Vue.extend({
  props: {
    id: Number,
    showSkipBtn: {
      type: Boolean,
      default: false
    }
  }
});

@Component({
  components: {
    mdbAlert,
    mdbCol,
    mdbContainer,
    mdbRow,
    mdbSelect,
    PaymentMethodSquare,
    ProfilePhoto
  }
})
export default class InvoiceComponent extends InvoiceProps {
  bankStore: BankModule = getModule(BankModule, this.$store);
  navStore: NavModule = getModule(NavModule, this.$store);
  profileStore: ProfileModule = getModule(ProfileModule, this.$store);
  activeSection = 'form';
  isProcessing: boolean = false;
  errorMessage: string | null = null;
  MQ = MQ;
  idempotent: string | null = null;
  age: string | null = null;
  authUser: User | null = null;
  orderType: string = 'New';
  participants: any[] = [];
  nonce: string | null = null;

  get amountDue(): number {
    const amount = this.orderType === 'Replacement' ? 25 : 0;
    if (amount !== undefined) return amount;
    return 0.0
  }

  get amountDueVal(): string {
    return this.amountDue.toFixed(2);
  }

  get isInitialized() {
    if (this.amountDue <= 0) return false;
    if (this.idempotent == null) return false;
    if (this.profileStore.organizationId == null || this.profileStore.organizationId === undefined) return false;
    if (this.profileStore.userId === undefined) return false;
    return true;
  }

  get authUserId(): string | undefined {
    if (this.selectedUser != null) {
      return this.selectedUser.userId;
    }
    return undefined;
  }

  get imageUrl(): string | undefined {
    if (this.selectedUser != null) {
      return this.selectedUser.imageUrl;
    }
    return undefined;
  }

  get disableSubmit(): boolean {
    if (this.selectedUser == null) return true;
    
    return false;
  }

  get selectedUser(): User | null {
    let userId: string | undefined;
    for (const p of this.participants) {
      if (p.selected === true) {
        userId = p.value;
      }
    }
    if (userId === undefined) return null;
    const people = this.profileStore.authorizedActiveUsers
      .concat(this.bankStore.contributingToActive);
    for (const p of people) {
      if (p.userId === userId) {
        this.navStore.setSelectedUser(p);
        return p;
      }
    }
    return null;
  }

  // get isFormValid() {
  //   if (
  //     this.profileStore.currOrganization.customPaymentOptions !== undefined &&
  //     /[\S]+/.test(this.userRequest.memberId || "")
  //   ) {
  //     for (let paymentOption of this.profileStore.currOrganization
  //       .customPaymentOptions) {
  //       if (
  //         paymentOption.slug === "member" &&
  //         paymentOption.regex !== undefined
  //       ) {
  //         let re = new RegExp(paymentOption.regex);
  //         return re.test(this.userRequest.memberId || "");
  //       }
  //     }
  //   }
  //   return /[\S]+/.test(this.userRequest.memberId || "");
  // }

  mounted() {
    this.reset();
  }

  reset() {
    this.activeSection = 'form';
    this.idempotent = uuidv1();
    const people = this.profileStore.authorizedActiveUsers
      .concat(this.bankStore.contributingToActive);
    this.participants = [];
    for (const p of people) {
      this.participants.push({
        text: `${p.firstName} ${p.lastName}`,
        value: p.userId
      })
    }
  }

  /** Return via the calling 'Next' button */
  @Emit('next')
  emitNext(e: any) {
    return e;
  }
  /** Handle the click event of the 'Next' button */
  async handlePostPaymentMethod(e: any) {
    this.nonce = e.nonce;
  }

  async handleSubmit() {
    // console.log('handleChargeCallback', e);
    this.errorMessage = null;
    this.isProcessing = true;
    let hasError = false;

    if (this.idempotent == null) return;

    if (this.authUserId === undefined) {
      this.errorMessage = 'Please selected a participant from the dropdown';
      return;
    }
    if (this.orderType === undefined) {
      this.errorMessage = 'Please select whether this is a new or replacement card';
      return;
    }
    if (this.imageUrl === undefined || this.imageUrl === '/img/campers/default.png') {
      this.errorMessage = 'Please click on the silhouette above to upload an image';
      return;
    }
    if ((this.nonce === null || this.nonce === undefined) && this.amountDue > 0) {
      this.errorMessage = 'Card card not captured correctly';
      return;
    }
    if (this.nonce === null || this.nonce === undefined) {
      this.nonce = 'NA';
    }

    const req = new IdCardPaymentRequest(Math.round(this.amountDue * 100), this.authUserId, this.idempotent, this.imageUrl, this.nonce, this.profileStore.organizationId || 'UNSET', this.profileStore.userId || 'UNSET', 'DECIMAL');
    req.orderType = this.orderType;

    const url = `${ApiEndpoints.apiEndpoint}/v2/bank/payment/idcard/square`;
    // console.log('idcard submit', url, req);
    const res = await apiSvc.httpPost(url, req).catch(err => {
      this.errorMessage = err.message;
      hasError = true;
    });
    this.isProcessing = false;
    // console.log('idcard payment res', hasError, res);
    if (hasError) return;
    if (!res || !res.data || res.data === undefined) {
      this.errorMessage = 'Server did not respond. Please reload the page to try again.'
      return
    }
    if (res.data.code === 'Error') {
      this.errorMessage = res.data.message || 'Indeterminate error occurred';
      this.reset();
      return;
    }
    if (res.data.code === 'OK' && res.data.item !== undefined && res.data.item.status === 'error') {
      const util = new SquareUtils();
      const msg = util.formatErrorMessage(res.data.item.processorErrorName);

      if (msg !== undefined) {
        this.errorMessage = `${msg}. Please check and retry`;
      } else {
        this.errorMessage = res.data.item.processorErrorMessage || res.data.item.paymentNotes || 'Indeterminate error occurred';
      }
      this.reset();
      return;
    }
    this.activeSection = 'success';
    // emit to parent that the 'next' event happened
    await this.profileStore.fetchUserDetails();
    // this.emitNext();
  }

  /** Handle the click event of the 'Skip' button */
  @Emit('skip')
  handleSkip(e: any) {
    // emit to parent that the 'skip' event happened
    return e;
  }
}
